import FlashLib from 'flashlib_onlyplay';
import EntryPoint from 'Engine/EntryPoint';
import eGameMode from '../enums/eGameMode';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';

export default class ControllerSlot extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.mode = EntryPoint.GameModel.gameMode;
    this.addListeners();
  }

  init() {
    const slotContainer = this.getChildByName('slotContainer');
    this.reelsContainer = slotContainer.getChildByName('reelsContainer');
    this.bonusReelsContainer = slotContainer.getChildByName('bonusReelsContainer');

    this.background = slotContainer.getChildByName('reelsBackground');
    // this.frontalContainer = slotContainer.getChildByName('frontalObjectsContainer');
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_START__SHOWN_UP, this.toggleMode, this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_END__SHOWN_UP, this.toggleMode, this);
    GlobalDispatcher.add(eEventTypes.EET_WINNINGS_CONTROLLER__SLOW_WIN, this.showWin, this);
  }

  toggleMode = () => {
    this.mode = EntryPoint.GameModel.freespinsEnabled ? eGameMode.EGM_BONUS : eGameMode.EGM_REGULAR;
  };

  start() {
    this.currentContainer.start();
  }

  stop() {
    const data = EntryPoint.GameModel.getReels(this._mode);
    this.currentContainer.stop(data);
  }

  showWin(data) {
    // this.background.playWinAnimation();
    this.currentContainer.showWin(data);
  }

  getNextContainer(mode) {
    switch (mode) {
      case eGameMode.EGM_REGULAR:
        this.bonusReelsContainer.hide();
        this.reelsContainer.show();
        return this.reelsContainer;
      case eGameMode.EGM_BONUS:
        this.reelsContainer.hide();
        this.bonusReelsContainer.show();
        return this.bonusReelsContainer;
      default:
        throw new Error(`Unhandled game mode ${mode}`);
    }
  }

  get willShowBonusStartAnimation() {
    return this.currentContainer = this.reelsContainer && this.reelsContainer.willShowScattersAnimation;
  }

  set mode(mode) {
    this._mode = mode;
    this.currentContainer = this.getNextContainer(mode);

    this.background.mode = mode;
    // this.frontalContainer.mode = mode;
  }
}
